import * as types from '../mutation-types'
import dashboard from '../../api/dashboard';

// initial state
const state = {
    loaded: false,
    location: {
        name: ''
    }
}

// getters
const getters = {
    loaded: state => state.loaded,
    location: state => state.location
}

// actions
const actions = {
    async loadLocation({commit, dispatch}, locationId) {
        try {
            let resp = await dashboard.loadLocation(locationId)
            commit(types.DASHBOARD_LOAD_LOCATION, resp.data)
        } catch (error) {
            dispatch('notification/updateError', error, {root: true})
        }
    },
    async updateLocation({commit, dispatch}, data) {
        try {
            let resp = await dashboard.updateLocation(data)
            commit(types.DASHBOARD_LOAD_LOCATION, resp.data)
            dispatch('notification/updateError', null, {root:true})
            dispatch('notification/updateSuccess', 'Erfolgreich geändert.', {root:true})
        } catch (error) {
            dispatch('notification/updateError', error, {root:true})
            dispatch('notification/updateSuccess', null, {root:true})
        }
    }
}

// mutations
const mutations = {
    [types.DASHBOARD_LOAD_LOCATION](state, data) {
        state.loaded = true
        state.location = data
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
